import React from "react";

const BackSecondsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <defs>
        <clipPath id="clipPath9463655104">
          <path
            d="M0 0L28 0L28 28L0 28L0 0Z"
            fillRule="nonzero"
            transform="matrix(1 0 0 1 0 0)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath9463655104)">
        <path
          d="M9.33333 4.66667L9.33333 0L3.5 5.83333L9.33333 11.6667L9.33333 7C13.195 7 16.3333 10.1383 16.3333 14C16.3333 17.8617 13.195 21 9.33333 21C5.47167 21 2.33333 17.8617 2.33333 14L0 14C0 19.1567 4.17667 23.3333 9.33333 23.3333C14.49 23.3333 18.6667 19.1567 18.6667 14C18.6667 8.84333 14.49 4.66667 9.33333 4.66667Z"
          fillRule="nonzero"
          transform="matrix(1 0 0 1 4.655 1.16667)"
          fill="rgb(255, 255, 255)"
        />
        <path
          d="M2.17 5.04L1.17833 5.04L1.17833 1.23667L0 1.59833L0 0.793334L2.065 0.0583336L2.17 0.0583336L2.17 5.04ZM7.16333 2.98667C7.16333 3.36 7.12833 3.68667 7.04667 3.94333C6.965 4.2 6.84833 4.43333 6.70833 4.60833C6.56833 4.78333 6.38167 4.91167 6.18333 4.99333C5.985 5.075 5.75167 5.11 5.495 5.11C5.23833 5.11 5.01667 5.075 4.80667 4.99333C4.59667 4.91167 4.42167 4.78333 4.27 4.60833C4.11833 4.43333 4.00167 4.21167 3.92 3.94333C3.83833 3.675 3.79167 3.36 3.79167 2.98667L3.79167 2.12333C3.79167 1.75 3.82667 1.42333 3.90833 1.16667C3.99 0.910001 4.10667 0.676667 4.24667 0.501667C4.38667 0.326667 4.57333 0.198333 4.77167 0.116667C4.97 0.0350008 5.20333 0 5.46 0C5.71667 0 5.93833 0.0349997 6.14833 0.116667C6.35833 0.198335 6.53333 0.326667 6.685 0.501667C6.83667 0.676667 6.95333 0.898334 7.035 1.16667C7.11667 1.435 7.16333 1.75 7.16333 2.12333L7.16333 2.98667ZM6.17167 1.98333C6.17167 1.76167 6.16 1.575 6.125 1.42333C6.09 1.27167 6.04333 1.155 5.985 1.06167C5.92667 0.968332 5.85667 0.898333 5.76333 0.863333C5.67 0.828333 5.57667 0.804999 5.47167 0.804999C5.36667 0.804999 5.26167 0.828333 5.18 0.863333C5.09833 0.898333 5.01667 0.968333 4.95833 1.06167C4.9 1.155 4.85333 1.27167 4.81833 1.42333C4.78333 1.575 4.77167 1.76167 4.77167 1.98333L4.77167 3.115C4.77167 3.33667 4.78333 3.52333 4.81833 3.675C4.85333 3.82667 4.9 3.955 4.95833 4.04833C5.01667 4.14167 5.08667 4.21167 5.18 4.24667C5.27333 4.28167 5.36667 4.305 5.47167 4.305C5.57667 4.305 5.68167 4.28167 5.76333 4.24667C5.845 4.21167 5.92667 4.14167 5.985 4.04833C6.04333 3.955 6.09 3.82667 6.11333 3.675C6.13667 3.52333 6.16 3.33667 6.16 3.115L6.16 1.98333L6.17167 1.98333Z"
          fillRule="nonzero"
          transform="matrix(1 0 0 1 10.535 13.6267)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default BackSecondsIcon;
